import type { ApiError } from '@/types/api.types';

type TranslateFn = (key: string) => string;

export function mapSpecialtiesError(error: ApiError, t: TranslateFn, fallbackKey: string): string {
  switch (error.code) {
    case 'UNAUTHORIZED':
      return t('specialties.errors.unauthorized');
    case 'FORBIDDEN':
      return t('specialties.errors.forbidden');
    case 'ACCOUNT_NOT_FOUND':
      return t('specialties.errors.accountNotFound');
    case 'SPECIALTY_NOT_FOUND':
      return t('specialties.errors.specialtyNotFound');
    case 'UNSUPPORTED_LANGUAGE':
      return t('specialties.errors.unsupportedLanguage');
    case 'SLUG_CONFLICT':
      return t('specialties.errors.slugConflict');
    case 'VALIDATION_ERROR':
      return t('specialties.errors.validationError');
    case 'INTERNAL_SERVER_ERROR':
      return t('specialties.errors.serverError');
    default:
      return t(fallbackKey);
  }
}
